import { render, staticRenderFns } from "./UpdateClassroom.vue?vue&type=template&id=5e83310e&scoped=true"
import script from "./UpdateClassroom.vue?vue&type=script&lang=js"
export * from "./UpdateClassroom.vue?vue&type=script&lang=js"
import style0 from "./UpdateClassroom.vue?vue&type=style&index=0&id=5e83310e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e83310e",
  null
  
)

export default component.exports